// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactAlert from "react-alert";
import * as Core from "@material-ui/core";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as App_Icon$DvmAdminFrontendFr from "../../icons/App_Icon.bs.js";
import * as Route_Paths$DvmAdminFrontendFr from "../../../../route/Route_Paths.bs.js";
import * as SimpleAlert$DvmAdminFrontendFr from "../../../../alert/SimpleAlert.bs.js";
import * as Utils_Alert$DvmAdminFrontendFr from "../../../utils/Utils_Alert.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../context/user/User_Context.bs.js";
import * as Context_Router$DvmAdminFrontendFr from "../../../../context/router/Context_Router.bs.js";
import * as Messages_Energy$DvmAdminFrontendFr from "../../../../intl/messages/energy/Messages_Energy.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../types/App_Types_Result.bs.js";
import * as App_Types_Status$DvmAdminFrontendFr from "../../../types/App_Types_Status.bs.js";
import * as App_Styles_Common$DvmAdminFrontendFr from "../../../styles/App_Styles_Common.bs.js";
import * as Model_Version_Api$DvmAdminFrontendFr from "../../../../pages/modelVersionList/Model_Version_Api.bs.js";
import * as App_OverlaySpinner$DvmAdminFrontendFr from "../../App_OverlaySpinner.bs.js";
import * as Model_Version_Form$DvmAdminFrontendFr from "../../../../pages/modelVersionList/Model_Version_Form.bs.js";
import * as Bonuses_Search_Form$DvmAdminFrontendFr from "../../../../pages/bonusesList/Bonuses_Search_Form.bs.js";
import * as Messages_ModelVersion$DvmAdminFrontendFr from "../../../../intl/messages/modelVersion/Messages_ModelVersion.bs.js";
import * as Contract_Errors_Router$DvmAdminFrontendFr from "../../../../pages/upload/contractErrors/Contract_Errors_Router.bs.js";
import * as Messages_Pool_Expenses$DvmAdminFrontendFr from "../../../../intl/messages/poolExpenses/Messages_Pool_Expenses.bs.js";
import * as Messages_Contract_Errors$DvmAdminFrontendFr from "../../../../intl/messages/contract/Messages_Contract_Errors.bs.js";
import * as App_TopMenu_Notifications_Api$DvmAdminFrontendFr from "./App_TopMenu_Notifications_Api.bs.js";

function App_TopMenu_Notifications_Item(Props) {
  var refetch = Props.refetch;
  var notification = Props.notification;
  var setModal = Props.setModal;
  var alert = ReactAlert.useAlert();
  var intl = ReactIntl.useIntl();
  var match = React.useState(function () {
        return /* NotStarted */0;
      });
  var setDismissResult = match[1];
  var dismissResult = match[0];
  var match$1 = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$2 = match$1[0];
  var userManager = match$2.userManager;
  var selectedRole = match$2.selectedRole;
  var match$3 = React.useState(function () {
        return {
                TAG: /* ModelPage */0,
                _0: /* NotStarted */0
              };
      });
  var setTablePage = match$3[1];
  var tablePage = match$3[0];
  var match$4 = Curry._1(Context_Router$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var dispatch = match$4[1];
  var dismiss = function (param) {
    App_TopMenu_Notifications_Api$DvmAdminFrontendFr.dismissNotification(userManager, setDismissResult, selectedRole, notification.parent, undefined, undefined);
  };
  React.useEffect((function () {
          if (tablePage.TAG !== /* ModelPage */0) {
            var result = tablePage._0;
            if (typeof result === "number") {
              result === /* NotStarted */0;
            } else if (result.TAG === /* Ok */0) {
              Belt_Option.mapWithDefault(Belt_List.head(result._0.content), undefined, (function (version) {
                      Curry._1(dispatch, {
                            TAG: /* StoreModelVersionFilter */2,
                            _0: {
                              brand: Model_Version_Form$DvmAdminFrontendFr.initialState.brand,
                              model: Model_Version_Form$DvmAdminFrontendFr.initialState.model,
                              version: Model_Version_Form$DvmAdminFrontendFr.initialState.version,
                              phase: Model_Version_Form$DvmAdminFrontendFr.initialState.phase,
                              modelLabel: Model_Version_Form$DvmAdminFrontendFr.initialState.modelLabel,
                              versionLabel: Model_Version_Form$DvmAdminFrontendFr.initialState.versionLabel,
                              motorization: Model_Version_Form$DvmAdminFrontendFr.initialState.motorization,
                              emptyMotorization: Model_Version_Form$DvmAdminFrontendFr.initialState.emptyMotorization,
                              active: Model_Version_Form$DvmAdminFrontendFr.initialState.active,
                              tableType: /* Version */1,
                              additionDate: version.additionDate
                            }
                          });
                      RescriptReactRouter.push(Route_Paths$DvmAdminFrontendFr.rManage + Route_Paths$DvmAdminFrontendFr.rModelVersionList);
                    }));
            } else {
              Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                        message: {
                          TAG: /* RestError */2,
                          _0: result._0
                        }
                      }));
            }
          }
          
        }), [tablePage]);
  React.useEffect((function () {
          if (typeof dismissResult === "number") {
            dismissResult === /* NotStarted */0;
          } else if (dismissResult.TAG === /* Ok */0) {
            var match = notification.parent;
            if (match !== 4) {
              if (match >= 5) {
                Model_Version_Api$DvmAdminFrontendFr.fetchVersionSearch(undefined, userManager, setTablePage, "?limit=1&offset=0&orderBy=-additionDate", selectedRole);
              } else {
                Curry._1(refetch, undefined);
              }
            } else {
              var newrecord = Caml_obj.obj_dup(Bonuses_Search_Form$DvmAdminFrontendFr.initialState);
              Curry._1(dispatch, {
                    TAG: /* StoreBonusesPERFFilter */20,
                    _0: (newrecord.status = {
                        hd: App_Types_Status$DvmAdminFrontendFr.toString(/* TOVALIDATE */8),
                        tl: /* [] */0
                      }, newrecord)
                  });
              RescriptReactRouter.push(Route_Paths$DvmAdminFrontendFr.rManage + Route_Paths$DvmAdminFrontendFr.rBonuses);
            }
          } else {
            Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                      message: {
                        TAG: /* RestError */2,
                        _0: dismissResult._0
                      }
                    }));
          }
        }), [dismissResult]);
  var match$5 = notification.parent;
  var match$6;
  switch (match$5) {
    case /* ALLOCATIONS_TO_BE_CHECKED */0 :
        match$6 = [
          "orange",
          /* Money */65,
          Messages_Pool_Expenses$DvmAdminFrontendFr.allocationsToBeChecked,
          (function (param) {
              Curry._1(setModal, (function (param) {
                      return true;
                    }));
            })
        ];
        break;
    case /* CONTRACTS_MISCONFIGURATED */1 :
        match$6 = [
          "red",
          /* HelpWarning */0,
          Messages_Contract_Errors$DvmAdminFrontendFr.tooltipIconMessage,
          (function (param) {
              Contract_Errors_Router$DvmAdminFrontendFr.routeToPage(undefined);
            })
        ];
        break;
    case /* ENGINE_TYPES_ADDED */2 :
        match$6 = [
          "orange",
          /* CheckOil */69,
          Messages_Energy$DvmAdminFrontendFr.newEnergyTypesIconNotification,
          (function (param) {
              dismiss(undefined);
            })
        ];
        break;
    case /* ENGINE_TYPES_MISSING */3 :
        match$6 = [
          "orange",
          /* FuelPump */67,
          Messages_ModelVersion$DvmAdminFrontendFr.tooltipMissingMotorizations,
          (function (param) {
              Curry._1(dispatch, {
                    TAG: /* StoreModelVersionFilter */2,
                    _0: {
                      brand: Model_Version_Form$DvmAdminFrontendFr.initialState.brand,
                      model: Model_Version_Form$DvmAdminFrontendFr.initialState.model,
                      version: Model_Version_Form$DvmAdminFrontendFr.initialState.version,
                      phase: Model_Version_Form$DvmAdminFrontendFr.initialState.phase,
                      modelLabel: Model_Version_Form$DvmAdminFrontendFr.initialState.modelLabel,
                      versionLabel: Model_Version_Form$DvmAdminFrontendFr.initialState.versionLabel,
                      motorization: Model_Version_Form$DvmAdminFrontendFr.initialState.motorization,
                      emptyMotorization: true,
                      active: "TRUE",
                      tableType: /* Version */1,
                      additionDate: Model_Version_Form$DvmAdminFrontendFr.initialState.additionDate
                    }
                  });
              RescriptReactRouter.push(Route_Paths$DvmAdminFrontendFr.rManage + Route_Paths$DvmAdminFrontendFr.rModelVersionList);
            })
        ];
        break;
    case /* REQUESTS_TO_BE_VALIDATED */4 :
        match$6 = [
          "orange",
          /* Agreement */55,
          Messages_Pool_Expenses$DvmAdminFrontendFr.requestsToBeValidated,
          (function (param) {
              dismiss(undefined);
            })
        ];
        break;
    case /* VERSIONS_ADDED */5 :
        match$6 = [
          "orange",
          /* CarPark */7,
          Messages_ModelVersion$DvmAdminFrontendFr.newVersionsIconNotification,
          (function (param) {
              dismiss(undefined);
            })
        ];
        break;
    
  }
  return React.createElement(Core.Box, {
              children: React.createElement(Core.Tooltip, {
                    arrow: true,
                    children: React.createElement("div", undefined, React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
                              show: App_Types_Result$DvmAdminFrontendFr.isPending(dismissResult),
                              children: React.createElement(Core.Button, {
                                    onClick: match$6[3],
                                    children: React.createElement(App_Icon$DvmAdminFrontendFr.make, {
                                          size: /* XLarge */4,
                                          type_: match$6[1],
                                          color: match$6[0]
                                        })
                                  })
                            })),
                    classes: {
                      tooltip: App_Styles_Common$DvmAdminFrontendFr.tooltip
                    },
                    placement: "bottom",
                    title: React.createElement("p", undefined, intl.formatMessage(match$6[2]))
                  })
            });
}

var make = App_TopMenu_Notifications_Item;

export {
  make ,
}
/* react Not a pure module */
